import type { VoidFunctionComponent } from 'react';

import { Category } from '../../../../../shared/issuesV2';
import Loader from '../../../generic/Loader';
import { usePolicies } from '../../../shared/policies/hooks';
import Header from '../../../shared/settings/SettingsPageHeader';
import OrganizationSettingsPermissionGate from '../../OrganizationSettingsPermissionGate';
import { shouldDisplayProjectIssueSettings } from '../../shared/permissions';

import Containers from './Containers';
import Licensing from './Licensing';
import Quality from './Quality';
import SBOM from './SBOM';
import Security from './Security';

/**
 * SettingsOrganizationProjectIssues is the settings page for managing
 * the default issue settings for projects.
 */
const SettingsOrganizationProjectIssues: VoidFunctionComponent = () => {
  const { policies, isLoading } = usePolicies();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Header heading="Default Issue Policies Settings" />
      <Licensing policies={policies[Category.Licensing]} />
      <Security policies={policies[Category.Vulnerability]} />
      <Quality policies={policies[Category.Quality]} />
      <SBOM policies={policies.SBOM} />
      <Containers />
    </>
  );
};

/**
 * SettingsOrganizationProjectIssuesContainer displays the project issue settings page if the user has permission to view it.
 */
const SettingsOrganizationProjectIssuesContainer: VoidFunctionComponent = () => (
  <OrganizationSettingsPermissionGate checkPermission={shouldDisplayProjectIssueSettings}>
    <SettingsOrganizationProjectIssues />
  </OrganizationSettingsPermissionGate>
);

export default SettingsOrganizationProjectIssuesContainer;
